import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";
import { uploadInChunks } from "src/domains/projects-list/api/chunkedUpload/uploadInChunks";
import type { LayerDataUiType } from "src/domains/projects-list/project-query/projects.models";

export interface UploadLayerDataParams {
  /** 업로드 채널 — URL `/{channel}/uploads` 세그먼트다(박스 타입과 같은 어휘, line 박스는 `line`). */
  channel: LayerDataUiType;
  /** 업로드 파일명 `{이름}.{확장자}` — stem 이 레이어 이름이 된다. NFD 정규화는 호출 측 책임. */
  fileName: string;
  /** 원본 바이너리. */
  file: File;
}

export interface UploadLayerDataResponse {
  /** 적재된 레이어 이름(파일명 stem + NFD 정규화). */
  layer_name: string;
}

/**
 * 512KB 고정 청크 순차 업로드(`uploadInChunks` 공용 헬퍼 위임) — 마지막 청크(last=true) 응답의
 * `layer_name` 수신으로 완료를 판별해 반환한다. gis 채널은 tif/tiff 와 dxf/dwg 가 같은 경로를 쓰고
 * 서버가 확장자로 분기한다. deprecated 구 경로(`/gis-uploads`)를 쓰지 않는다.
 */
export async function uploadLayerData(
  projectId: number,
  { channel, fileName, file }: UploadLayerDataParams
): Promise<UploadLayerDataResponse> {
  const layerName = await uploadInChunks<string>({
    url: `${backendBaseUrl()}/projects/${projectId}/${channel}/uploads`,
    fileName,
    file,
    pickCompletion: (data) => data.layer_name as string | undefined,
    label: `${channel} 업로드`,
  });
  return { layer_name: layerName };
}
